/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Addattachments1Inputs */

const en_common_addattachments1 = /** @type {(inputs: Common_Addattachments1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add attachments`)
};

/**
* | output |
* | --- |
* | "Add attachments" |
*
* @param {Common_Addattachments1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const common_addattachments1 = /** @type {((inputs?: Common_Addattachments1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Addattachments1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_common_addattachments1(inputs)
});
export { common_addattachments1 as "common_addAttachments" }